let lastScrollTop = 0;
const stickyNav = document.querySelector(".mobile-sticky-nav");
const scrollToTopButtom = document.querySelector(".scroll__to__top--parent");

window.addEventListener("scroll", function () {
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  let isScrollingDown = scrollTop > lastScrollTop;

  if (isScrollingDown) {
    // Scrolling down
    stickyNav.classList.remove("hidden");
    scrollToTopButtom.style.bottom = "4.5rem";
  } else {
    // Scrolling up
    stickyNav.classList.add("hidden");
    scrollToTopButtom.style.bottom = "1rem";
  }
  lastScrollTop = scrollTop;
});